export const manufacturerIcons = {
  "Nintendo": {
    "icon": `${konsolenkostPluginInstantSearchPath}/images/icons/manufacturer/nintendo.svg`,
    "color": "#CC2131",
    "textColor": "#FFFFFF"
  },
  "Acclaim": {
    "icon": `${konsolenkostPluginInstantSearchPath}/images/icons/manufacturer/acclaim.svg`,
    "color": "#000000",
    "textColor": "#FFFFFF"
  },
  "Konami": {
    "icon": `${konsolenkostPluginInstantSearchPath}/images/icons/manufacturer/konami.svg`,
    "color": "#8F99A4",
    "textColor": "#000000"
  },
  "Atari": {
    "icon": `${konsolenkostPluginInstantSearchPath}/images/icons/manufacturer/atari.svg`,
    "color": "#E62128",
    "textColor": "#FFFFFF"
  },
  "Ubisoft": {
    "icon": `${konsolenkostPluginInstantSearchPath}/images/icons/manufacturer/ubisoft.svg`,
    "color": "#25085F",
    "textColor": "#FFFFFF"
  },
  "Activision": {
    "icon": `${konsolenkostPluginInstantSearchPath}/images/icons/manufacturer/activision.svg`,
    "color": "#31006B",
    "textColor": "#FFFFFF"
  },
  "Capcom": {
    "icon": `${konsolenkostPluginInstantSearchPath}/images/icons/manufacturer/capcom.svg`,
    "color": "#88DDFF",
    "textColor": "#000000"
  },
  "Electronic Arts GmbH": {
    "icon": `${konsolenkostPluginInstantSearchPath}/images/icons/manufacturer/ea.svg`,
    "color": "#FF4747",
    "textColor": "#FFFFFF"
  },
  "EIDOS GmbH": {
    "icon": `${konsolenkostPluginInstantSearchPath}/images/icons/manufacturer/eidos-interactive.svg`,
    "color": "#F3F3F3",
    "textColor": "#000000"
  },
  "Disney Interactive Studios": {
    "icon": `${konsolenkostPluginInstantSearchPath}/images/icons/manufacturer/disney-interactive.svg`,
    "color": "#FFFFFF",
    "textColor": "#000000"
  },
  "Sega": {
    "icon": `${konsolenkostPluginInstantSearchPath}/images/icons/manufacturer/sega.svg`,
    "color": "#0060A8",
    "textColor": "#FFFFFF"
  },
  "Sony": {
    "icon": `${konsolenkostPluginInstantSearchPath}/images/icons/manufacturer/sony.svg`,
    "color": "#000000",
    "textColor": "#FFFFFF"
  },
  "Panasonic": {
    "icon": `${konsolenkostPluginInstantSearchPath}/images/icons/manufacturer/panasonic.svg`,
    "color": "#2866AD",
    "textColor": "#FFFFFF"
  },
  "Apple": {
    "icon": `${konsolenkostPluginInstantSearchPath}/images/icons/manufacturer/apple.svg`,
    "color": "#FFFFFF",
    "textColor": "#000000"
  },
  "Commodore": {
    "icon": `${konsolenkostPluginInstantSearchPath}/images/icons/manufacturer/commodore.svg`,
    "color": "#EEF1DB",
    "textColor": "#000000"
  },
  "Microsoft": {
    "icon": `${konsolenkostPluginInstantSearchPath}/images/icons/manufacturer/microsoft.svg`,
    "color": "#0e7a0d",
    "textColor": "#FFFFFF"
  },
  "Philips": {
    "icon": `${konsolenkostPluginInstantSearchPath}/images/icons/manufacturer/philips.svg`,
    "color": "#1978BE",
    "textColor": "#FFFFFF"
  },
  "SNK": {
    "icon": `${konsolenkostPluginInstantSearchPath}/images/icons/manufacturer/snk.svg`,
    "color": "#0066FF",
    "textColor": "#FFFFFF"
  },
  "NEC": {
    "icon": `${konsolenkostPluginInstantSearchPath}/images/icons/manufacturer/nec.svg`,
    "color": "#1414A0",
    "textColor": "#FFFFFF"
  },
  "LEGO": {
    "icon": `${konsolenkostPluginInstantSearchPath}/images/icons/manufacturer/lego.svg`,
    "color": "#D01012",
    "textColor": "#000000"
  },
}
